import Discovery from "./components/Discovery";
import Connections from "./components/Connections";
import UserStats from "./components/UserStats";
import Insights from "./components/Insights";
import Metrics from "./components/Metrics";
import MatchStats from "./components/MatchStats";
import Notifications from "./components/Notifications";
import Analytics from "./components/Analytics";
import { useEffect } from "react";

const Dashboard = () => {
  
  useEffect(() => {
    console.log('═══════════════════════════════════════════════════════');
    console.log('📊 DASHBOARD LOADING - Checking for cached data...');
    console.log('═══════════════════════════════════════════════════════');
  }, []);
  
  return (
    <>
      <div className="mt-4 flex h-full w-full flex-col gap-[20px] rounded-[20px] xl:flex-row">
        <div className="h-full w-full rounded-[20px]">
          {/* left side */}
          <div className="col-span-9 h-full w-full rounded-t-2xl xl:col-span-6">
            {/* overall & Balance */}
            <div className="mb-5 grid grid-cols-6 gap-5">
            <div className="col-span-6">
                <Connections />
              </div>
              {/* <div className="col-span-6 w-full 3xl:col-span-2">
                <Balance />
              </div> */}
            </div>
            {/* Daily Traffic and.. */}
            <div className="mt-5 grid w-full grid-cols-6 gap-5">
              <div className="col-span-3">
                <Discovery />
              </div>
              <div className="col-span-3">
                <UserStats />
              </div>
              {/* <div className="col-span-6 3xl:col-span-2">
                <ProfitEstimation />
              </div> */}
            </div>
            {/* Platform Usage Metrics and Mentor Matching */}
            <div className="mt-5 grid w-full grid-cols-6 gap-5">
              <div className="col-span-3">
                <Metrics />
              </div>
              <div className="col-span-3">
                <MatchStats />
              </div>
            </div>
            {/* Notification Stats */}
            <div className="mt-5 grid w-full grid-cols-6 gap-5">
              <div className="col-span-6">
                <Notifications />
              </div>
            </div>
            {/* Your Transfers & tables */}
            {/* <div className="mt-5 grid w-full grid-cols-6 gap-5">
              <div className="col-span-6 3xl:col-span-2">
                <YourTransfers />
              </div>
              <div className="col-span-6 3xl:col-span-4">
                <MostVisited tableData={tableDataMostVisited} />
              </div>
            </div> */}
          </div>
        </div>

        {/* line */}
        {/* <div className="flex w-0 bg-gray-200 dark:bg-navy-700 xl:w-px" /> */}

        {/* right section */}
        <div className="w-full xl:w-[800px] xl:min-w-[300px] 2xl:min-w-[400px] flex flex-col">
          <Insights />
        </div>
      </div>
      
      {/* Full width Mentorship Analytics Hub */}
      <div className="mt-5">
        <Analytics />
      </div>
    </>
  );
};

export default Dashboard;
